import React from "react";
import { checkPasswordStrength, getStrengthColor, getStrengthLabel } from "../utils/passwordStrength";

/**
 * Password Strength Indicator Component
 * Shows visual feedback as user types password
 */
export default function PasswordStrengthIndicator({ password }) {
  if (!password) {
    return null;
  }

  const { score, strength, feedback, isValid } = checkPasswordStrength(password);

  return (
    <div className="mt-2">
      {/* Strength Bar */}
      <div className="flex gap-1 mb-2">
        {[1, 2, 3, 4, 5].map((level) => (
          <div
            key={level}
            className={`h-2 flex-1 rounded ${
              level <= score ? getStrengthColor(strength) : "bg-gray-200"
            }`}
          />
        ))}
      </div>

      {/* Strength Label */}
      <div className="flex items-center justify-between text-sm">
        <span className={`font-medium ${
          strength === "weak" ? "text-red-600" :
          strength === "fair" ? "text-orange-600" :
          strength === "good" ? "text-yellow-600" :
          strength === "strong" ? "text-green-600" :
          "text-green-700"
        }`}>
          {getStrengthLabel(strength)}
        </span>
        {isValid && (
          <span className="text-green-600 font-semibold">✓ Strong Password</span>
        )}
      </div>

      {/* Feedback Messages */}
      {feedback.length > 0 && (
        <div className="mt-2 text-xs text-gray-600">
          <p className="font-medium mb-1">Password must contain:</p>
          <ul className="list-disc list-inside space-y-0.5">
            {feedback.map((item, index) => (
              <li key={index} className="text-red-600">{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

